import { useState, useEffect } from 'react'

// Cookie consent banner with localStorage
function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false)
  const PRODUCTION_URL = 'https://wurlo.org'

  useEffect(() => {
    if (!localStorage.getItem('cookieConsent')) {
      setTimeout(() => setIsVisible(true), 1000)
    }
  }, [])

  const handleChoice = (choice) => {
    localStorage.setItem('cookieConsent', choice)
    setIsVisible(false)
  }

  if (!isVisible) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6 animate-slide-up">
      <div className="mx-auto max-w-6xl">
        <div className="rounded-2xl border-2 border-indigo-200 bg-white shadow-2xl backdrop-blur-sm p-4 sm:p-6">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            {/* Content */}
            <div className="flex-1">
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-indigo-600">
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M12 16v-4M12 8h.01"/>
                  </svg>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-slate-900 mb-1">
                    We use cookies
                  </h3>
                  <p className="text-sm text-slate-600 leading-relaxed">
                    We use cookies to enhance your experience and analyze site usage. 
                    By clicking "Accept", you agree to our use of cookies. 
                    Read our{' '}
                    <a 
                      href={`${PRODUCTION_URL}/privacy`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-indigo-600 hover:text-indigo-700 underline font-semibold"
                    >
                      Privacy Policy
                    </a>
                    {' '}to learn more.
                  </p>
                </div>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 w-full sm:w-auto">
              <button
                onClick={() => handleChoice('declined')}
                className="w-full sm:w-auto px-6 py-2.5 rounded-xl border-2 border-slate-300 text-slate-700 font-semibold hover:bg-slate-50 transition-colors focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-offset-2"
              >
                Decline
              </button>
              <button
                onClick={() => handleChoice('accepted')}
                className="w-full sm:w-auto px-6 py-2.5 rounded-xl bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-bold hover:from-indigo-700 hover:to-purple-700 shadow-lg transition-all focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                Accept All
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CookieConsent
